import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Featuresrealestate() {
  return (
    <section className="tabing_section features_real_estate features-retail p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} className="">
            <h3 className="h3_head">
              Future-<span>Ready Retail</span> App Development for Your Business
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Empower your retail business with a custom-built app that caters
              to modern retail demands. As a leading retail app development
              company, TekRevol delivers feature-rich, scalable solutions
              designed to streamline operations, enhance customer engagement,
              and drive growth with cutting-edge technology.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
            <div className="features-blue-box">
              <div className="features-scroll">
                <div className="feature-flex">
                  <div className="title" style={{ color: "#f47a14" }}>
                    01
                  </div>
                  <div className="title-content">
                    <h6>Seamless Mobile Shopping</h6>
                    <p>Real-time updates for effortless purchases.</p>
                  </div>
                </div>
                <div className="feature-flex">
                  <div className="title" style={{ color: "#f47a14" }}>
                    02
                  </div>
                  <div className="title-content">
                    <h6>Automated Inventory Sync</h6>
                    <p>Accurate stock levels, fewer errors.</p>
                  </div>
                </div>
                <div className="feature-flex">
                  <div className="title" style={{ color: "#f47a14" }}>
                    03
                  </div>
                  <div className="title-content">
                    <h6>Fast, Secure Payments</h6>
                    <p>Quick, safe, multi-currency checkouts.</p>
                  </div>
                </div>
                <div className="feature-flex">
                  <div className="title" style={{ color: "#f47a14" }}>
                    04
                  </div>
                  <div className="title-content">
                    <h6>Smart Product Recommendations</h6>
                    <p>AI-driven suggestions to boost sales.</p>
                  </div>
                </div>
                <div className="feature-flex">
                  <div className="title" style={{ color: "#f47a14" }}>
                    05
                  </div>
                  <div className="title-content">
                    <h6>Virtual Try-On Experience</h6>
                    <p>AR fitting rooms for enhanced engagement.</p>
                  </div>
                </div>
                <div className="feature-flex">
                  <div className="title" style={{ color: "#f47a14" }}>
                    06
                  </div>
                  <div className="title-content">
                    <h6>Centralized Admin Control</h6>
                    <p>Simple sales and vendor management dashboard.</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 text-center"
          >
            <div className="features-img">
              <StaticImage
                src="../../images/services-usa/retail-app/future-retail.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={450}
                height={896}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Featuresrealestate;
